<header
  class="site-header"
  [class.rtl]="lang === 'ar'"
  [class.lang-open]="langDropdownOpen"
>
  <div class="container">
    <!-- Desktop primary nav -->
    <nav
      class="main-nav desktop"
      [attr.dir]="lang === 'ar' ? 'rtl' : 'ltr'"
      aria-label="Main menu"
    >
      <ul class="menu-root">
        <!-- Home: icon + label -->
        <li class="menu-item home-link">
          <a
            [href]="
              lang === 'ar'
                ? mainWebsiteLink + '/ar/home'
                : mainWebsiteLink + '/en/home'
            "
            target="”_blank”"
            role="button"
            [attr.aria-label]="'trHeaderMenuGoHome' | translate"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon"
              viewBox="0 0 48 48"
              aria-hidden="true"
            >
              <path
                d="M 23.951172 4 A 1.50015 1.50015 0 0 0 23.072266 4.3222656 L 8.859375 15.519531 C 7.0554772 16.941163 6 19.113506 6 21.410156 L 6 40.5 C 6 41.863594 7.1364058 43 8.5 43 L 18.5 43 C 19.863594 43 21 41.863594 21 40.5 L 21 30.5 C 21 30.204955 21.204955 30 21.5 30 L 26.5 30 C 26.795045 30 27 30.204955 27 30.5 L 27 40.5 C 27 41.863594 28.136406 43 29.5 43 L 39.5 43 C 40.863594 43 42 41.863594 42 40.5 L 42 21.410156 C 42 19.113506 40.944523 16.941163 39.140625 15.519531 L 24.927734 4.3222656 A 1.50015 1.50015 0 0 0 23.951172 4 z M 24 7.4101562 L 37.285156 17.876953 C 38.369258 18.731322 39 20.030807 39 21.410156 L 39 40 L 30 40 L 30 30.5 C 30 28.585045 28.414955 27 26.5 27 L 21.5 27 C 19.585045 27 18 28.585045 18 30.5 L 18 40 L 9 40 L 9 21.410156 C 9 20.030807 9.6307412 18.731322 10.714844 17.876953 L 24 7.4101562 z"
              ></path>
            </svg>

            <span>{{ lang === 'ar' ? '' : 'Home' }}</span>
          </a>
        </li>

        <!-- Menus from JSON -->
        <li
          *ngFor="let item of menus; trackBy: trackById"
          class="menu-item"
          [class.has-children]="item.children?.length"
          [class.mega]="isMegaMenu(item)"
        >
          <!-- Top-level: link or label -->
          <a
            *ngIf="hrefOf(item) as h; else labelOnly"
            [href]="h"
            target="”_blank”"
          >
            {{ labelOf(item) }}
          </a>
          <ng-template #labelOnly>
            <span class="link-text">{{ labelOf(item) }}</span>
          </ng-template>

          <!-- ============== OUR SERVICES: MEGA MENU PANEL ============== -->
          <div *ngIf="isMegaMenu(item)" class="mega-panel">
            <!-- Category grid -->
            <div class="mega-grid">
              <div
                class="mega-col"
                *ngFor="let grp of groupsOf(item); trackBy: trackById"
              >
                <h4 class="mega-heading">{{ labelOf(grp) }}</h4>

                <ul class="mega-list">
                  <li
                    *ngFor="let svc of grp.children ?? []; trackBy: trackById"
                  >
                    <a
                      *ngIf="hrefOf(svc) as sh; else svcLabel"
                      [href]="sh"
                      target="”_blank”"
                    >
                      <span class="link-text">{{ labelOf(svc) }}</span>
                    </a>
                    <ng-template #svcLabel>
                      <span class="link-text">{{ labelOf(svc) }}</span>
                    </ng-template>
                  </li>
                </ul>

                <a
                  class="mega-viewall"
                  *ngIf="viewAllMeta(grp) as v"
                  [href]="v.href[lang]"
                  target="”_blank”"
                >
                  {{ v.label[lang] }}
                  <span class="count" *ngIf="v.count">({{ v.count }})</span>
                </a>
              </div>
            </div>

            <!-- Quick Links strip (below groups, 5 columns) -->
            <div class="mega-quick" *ngIf="quickLinksOf(item).length">
              <a
                *ngFor="let q of quickLinksOf(item); trackBy: trackById"
                class="quick-pill"
                [href]="hrefOf(q) || '#'"
                target="”_blank”"
              >
                <span class="link-text">{{ labelOf(q) }}</span>
              </a>
            </div>
          </div>

          <!-- ============== DEFAULT SUBMENU (non-mega) ============== -->
          <ul
            *ngIf="!isMegaMenu(item) && item.children?.length"
            class="submenu"
          >
            <li
              *ngFor="let ch of item.children; trackBy: trackById"
              class="menu-item"
              [class.has-children]="ch.children?.length"
            >
              <a
                *ngIf="hrefOf(ch) as hh; else subLabelOnly"
                [href]="hh"
                target="”_blank”"
              >
                <span class="link-text">{{ labelOf(ch) }}</span>
              </a>
              <ng-template #subLabelOnly>
                <span class="link-text">{{ labelOf(ch) }}</span>
              </ng-template>

              <ul *ngIf="ch.children?.length" class="submenu">
                <li
                  *ngFor="let g of ch.children; trackBy: trackById"
                  class="menu-item"
                >
                  <a
                    *ngIf="hrefOf(g) as gh; else gLabelOnly"
                    [href]="gh"
                    target="”_blank”"
                  >
                    <span class="link-text">{{ labelOf(g) }}</span>
                  </a>
                  <ng-template #gLabelOnly>
                    <span class="link-text">{{ labelOf(g) }}</span>
                  </ng-template>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </nav>

    <!-- Desktop utilities -->
    <div class="utilities desktop" *ngIf="utilities?.length">
      <!-- Accessibility (new utility) -->
      <div
        class="utility accessibility"
        (click)="toggleAccessibilityDropdown()"
      >
        <button
          class="util-btn"
          type="button"
          [attr.aria-expanded]="accessibilityDropdownOpen"
        >
          <svg
            fill="#92722a"
            width="25px"
            height="25px"
            viewBox="0 0 32 32"
            id="icon"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <defs>
                <style>
                  .cls-1 {
                    fill: none;
                  }
                </style>
              </defs>
              <title>accessibility--alt</title>
              <polygon
                points="23 14 23 12 9 12 9 14 14 14 14 16.734 10.132 23.504 11.868 24.496 15.58 18 16.42 18 20.132 24.496 21.868 23.504 18 16.734 18 14 23 14"
              ></polygon>
              <circle cx="16" cy="9" r="2"></circle>
              <path
                d="M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
              ></path>
              <rect
                id="_Transparent_Rectangle_"
                data-name="&lt;Transparent Rectangle&gt;"
                class="cls-1"
                width="32"
                height="32"
              ></rect>
            </g>
          </svg>
        </button>
        <ul *ngIf="accessibilityDropdownOpen" class="access-menu">
          <li>
            <a (click)="openAccessiblity()">
              <svg
                width="20px"
                height="20px"
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
                fill="#544f4f"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <circle
                    fill="none"
                    stroke="#544f4f"
                    stroke-linejoin="round"
                    stroke-width="32"
                    cx="256"
                    cy="56"
                    r="40"
                  ></circle>
                  <path
                    fill="none"
                    stroke="#544f4f"
                    stroke-linejoin="round"
                    stroke-width="32"
                    d="M204.23,274.44c2.9-18.06,4.2-35.52-.5-47.59-4-10.38-12.7-16.19-23.2-20.15L88,176.76c-12-4-23.21-10.7-24-23.94-1-17,14-28,29-24,0,0,88,31.14,163,31.14s162-31,162-31c18-5,30,9,30,23.79,0,14.21-11,19.21-24,23.94l-88,31.91c-8,3-21,9-26,18.18-6,10.75-5,29.53-2.1,47.59l5.9,29.63L351.21,467.9c2.8,13.15-6.3,25.44-19.4,27.74S308,489,304.12,476.28L266.56,360.35q-2.71-8.34-4.8-16.87L256,320l-5.3,21.65q-2.52,10.35-5.8,20.48L208,476.18c-4,12.85-14.5,21.75-27.6,19.46S158,480.05,160.94,467.9l37.39-163.83Z"
                  ></path>
                </g>
              </svg>
              {{ lang === 'ar' ? 'إمكانية الوصول' : 'Accessibility' }}
            </a>
          </li>
          <li>
            <a
              [href]="
                lang === 'ar'
                  ? mainWebsiteLink + '/ar/accessibility#sign-language'
                  : mainWebsiteLink + '/en/accessibility#sign-language'
              "
              target="”_blank”"
            >
              <svg
                width="20px"
                height="20px"
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
                fill="#544f4f"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    fill="var(--ci-primary-color, #544f4f)"
                    d="M256.16,72c65.3.46,118.745,53.964,119.131,119.269a120.126,120.126,0,0,1-33.161,83.545l22.631,22.631a152.141,152.141,0,0,0,42.53-106.365C406.8,108.36,339.105,40.586,256.385,40A150.765,150.765,0,0,0,149.849,82.536l22.629,22.628A119.24,119.24,0,0,1,256.16,72Z"
                    class="ci-primary"
                  ></path>
                  <path
                    fill="var(--ci-primary-color, #544f4f)"
                    d="M359.293,337.235h0l-32-32h0L243.3,221.241l-42.29-42.29h0l-24.843-24.843h0L38.058,16H15.293V38.489l98.294,98.294A151.914,151.914,0,0,0,103.293,192v32h32V192A120.77,120.77,0,0,1,139,162.2l28.324,28.324c-.021.791-.034,1.585-.034,2.381v85.729l5.089,5.082A118.419,118.419,0,0,1,207.293,368h32a150.125,150.125,0,0,0-40-102.453V222.489l128,128v26.178A63.4,63.4,0,0,1,263.96,440H239.293v32H263.96a95.452,95.452,0,0,0,95.161-89.684L472.805,496h22.488V473.234Z"
                    class="ci-primary"
                  ></path>
                  <path
                    fill="var(--ci-primary-color, #544f4f)"
                    d="M254.628,104A87.158,87.158,0,0,0,195.3,127.991l22.62,22.62A55.232,55.232,0,0,1,254.865,136h.428a56,56,0,0,1,56,56h32a88,88,0,0,0-88.665-88Z"
                    class="ci-primary"
                  ></path>
                </g>
              </svg>
              {{
                lang === 'ar'
                  ? 'مترجم لغة الإشارة'
                  : 'Sign Language Interpreter'
              }}
            </a>
          </li>
        </ul>
      </div>

      <!-- Language (icon + label) -->
      <div class="utility language" (click)="toggleLangDropdown()">
        <button
          class="util-btn"
          type="button"
          [attr.aria-expanded]="langDropdownOpen"
        >
          <span>{{ lang === 'en' ? 'AR' : 'EN' }}</span>
        </button>
        <ul *ngIf="langDropdownOpen" class="lang-menu">
          <li>
            <a [class.active-lang]="lang === 'ar'" (click)="changeLang('ar')"
              >عربي</a
            >
          </li>
          <li>
            <a [class.active-lang]="lang === 'en'" (click)="changeLang('en')"
              >English</a
            >
          </li>
        </ul>
      </div>
    </div>

    <div class="nav-shield" *ngIf="langDropdownOpen"></div>
  </div>

  <!-- ================= Mobile Drawer ================= -->
  <aside
    id="mobileNav"
    class="mobile-drawer"
    *ngIf="mobileOpen"
    [class.rtl]="lang === 'ar'"
  >
    <div class="mobile-topbar">
      <div class="mobile-logo">
        <img src="../../../../assets/icons/ae-logo.svg" alt="Logo" />
      </div>
      <div class="mobile-actions">
        <!-- Search -->
        <button
          class="icon-btn"
          type="button"
          aria-label="Search"
          (click)="toggleMobileSearch()"
        >
          <svg viewBox="0 0 24 24" class="icon">
            <path
              d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16a6.471 6.471 0 004.23-1.57l.27.28v.79L20 21.5 21.5 20l-6-6zM10 15a5 5 0 110-10 5 5 0 010 10z"
            />
          </svg>
        </button>
        <!-- Close -->
        <button
          class="icon-btn"
          type="button"
          aria-label="Close"
          (click)="toggleMobile()"
        >
          <svg viewBox="0 0 24 24" class="icon">
            <path
              d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
          </svg>
        </button>
      </div>
    </div>
    <!-- Mobile search panel -->
    <div
      class="mobile-search"
      *ngIf="mobileSearchOpen"
      [attr.dir]="lang === 'ar' ? 'rtl' : 'ltr'"
    >
      <div class="search-row">
        <svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16a6.471 6.471 0 004.23-1.57l.27.28v.79L20 21.5 21.5 20l-6-6z"
          />
        </svg>
        <input
          id="mobileSearchInput"
          type="search"
          [attr.placeholder]="
            lang === 'ar' ? 'ابحث في الموقع' : 'Search in website'
          "
          [value]="searchQuery"
          (input)="onSearchInput($event)"
          autocomplete="off"
          autocapitalize="none"
          spellcheck="false"
          role="combobox"
          aria-expanded="{{ !!filteredSuggestions.length }}"
          aria-autocomplete="list"
        />
        <!--<button
          type="button"
          class="clear-btn"
          *ngIf="searchQuery"
          (click)="clearSearch()"
          aria-label="Clear"
        >
          ✕
        </button>-->
      </div>

      <ul
        class="search-suggest"
        *ngIf="filteredSuggestions.length"
        role="listbox"
      >
        <li *ngFor="let s of filteredSuggestions; trackBy: trackByI">
          <a class="sugg-link" [href]="s.href[lang]">
            <span class="text">{{ s.label[lang] }}</span>
          </a>
        </li>
      </ul>
    </div>
    <nav class="mobile-menu" [attr.dir]="lang === 'ar' ? 'rtl' : 'ltr'">
      <ul>
        <!-- Home (icon + label) -->
        <li class="row">
          <a
            class="row-link"
            [href]="
              lang === 'ar'
                ? mainWebsiteLink + '/ar/home'
                : mainWebsiteLink + '/en/home'
            "
            target="”_blank”"
          >
            <svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
            </svg>
            <span>{{ lang === 'ar' ? 'الصفحة الرئيسية' : 'Home' }}</span>
          </a>
        </li>

        <!-- Top-level with collapsible submenus -->
        <li *ngFor="let item of menus; trackBy: trackById" class="row">
          <div class="row-main">
            <a
              class="row-link"
              *ngIf="hrefOf(item) as h; else mobileLabelOnly"
              [href]="h"
              target="”_blank”"
              >{{ labelOf(item) }}</a
            >
            <ng-template #mobileLabelOnly>
              <span class="row-label">{{ labelOf(item) }}</span>
            </ng-template>

            <button
              *ngIf="item.children?.length"
              type="button"
              class="chev"
              [class.open]="isMobileOpen(item.id)"
              (click)="toggleMobileSection(item.id)"
              aria-label="Toggle submenu"
            >
              <svg viewBox="0 0 24 24" class="icon">
                <path d="M7 10l5 5 5-5z" />
              </svg>
            </button>
          </div>

          <ul
            class="mobile-sub"
            *ngIf="item.children?.length"
            [class.open]="isMobileOpen(item.id)"
          >
            <!-- Mega menu flattened for mobile -->
            <ng-container *ngIf="isMegaMenu(item); else defaultMobile">
              <!-- 1) Groups first -->
              <li *ngFor="let grp of groupsOf(item); trackBy: trackById">
                <div class="sub-heading">{{ labelOf(grp) }}</div>
                <ul class="mobile-sub open no-indent">
                  <li
                    *ngFor="let svc of grp.children ?? []; trackBy: trackById"
                  >
                    <a class="sub-link" [href]="hrefOf(svc)" target="”_blank”">
                      <span class="link-text">{{ labelOf(svc) }}</span>
                    </a>
                  </li>
                </ul>
                <a
                  class="sub-viewall"
                  *ngIf="viewAllMeta(grp) as v"
                  [href]="v.href[lang]"
                  target="”_blank”"
                >
                  {{ v.label[lang] }}
                  <span *ngIf="v.count">({{ v.count }})</span>
                </a>
              </li>

              <!-- 2) Quick links after groups -->
              <li *ngIf="quickLinksOf(item).length" class="mobile-quick-wrap">
                <div class="mobile-quick">
                  <a
                    *ngFor="let q of quickLinksOf(item); trackBy: trackById"
                    class="quick-pill link-as-text"
                    [href]="hrefOf(q) || '#'"
                    target="”_blank”"
                  >
                    <span class="link-text">{{ labelOf(q) }}</span>
                  </a>
                </div>
              </li>
            </ng-container>

            <!-- Normal menu for others -->
            <ng-template #defaultMobile>
              <li *ngFor="let ch of item.children; trackBy: trackById">
                <a
                  *ngIf="hrefOf(ch) as hh; else childMobileLabel"
                  class="sub-link"
                  [href]="hh"
                  target="”_blank”"
                  >{{ labelOf(ch) }}</a
                >
                <ng-template #childMobileLabel>
                  <div class="sub-heading">{{ labelOf(ch) }}</div>
                </ng-template>

                <ul class="mobile-sub" *ngIf="ch.children?.length">
                  <li *ngFor="let sub of ch.children; trackBy: trackById">
                    <a
                      class="sub-link"
                      [href]="hrefOf(sub)"
                      target="”_blank”"
                      >{{ labelOf(sub) }}</a
                    >
                  </li>
                </ul>
              </li>
            </ng-template>
          </ul>
        </li>

        <!-- Separator -->
        <li class="row util-sep"></li>

        <!-- Mobile accessibility (new) -->
        <li class="row accessibility-mobile">
          <div class="row-main">
            <div class="row-label">
              <span>{{
                lang === 'ar' ? 'إمكانية الوصول' : 'Accessibility'
              }}</span>
            </div>

            <!-- toggle button -->
            <button
              type="button"
              class="chev"
              [class.open]="accessibilityMobileOpen"
              (click)="toggleAccessibilityMobile()"
              aria-label="Toggle accessibility options"
            ></button>
          </div>

          <!-- DROPDOWN LIST same as other menus -->
          <ul class="mobile-sub" [class.open]="accessibilityMobileOpen">
            <li>
              <a class="sub-link" (click)="openAccessiblity()">
                <svg
                  width="20px"
                  height="20px"
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#544f4f"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <circle
                      fill="none"
                      stroke="#544f4f"
                      stroke-linejoin="round"
                      stroke-width="32"
                      cx="256"
                      cy="56"
                      r="40"
                    ></circle>
                    <path
                      fill="none"
                      stroke="#544f4f"
                      stroke-linejoin="round"
                      stroke-width="32"
                      d="M204.23,274.44c2.9-18.06,4.2-35.52-.5-47.59-4-10.38-12.7-16.19-23.2-20.15L88,176.76c-12-4-23.21-10.7-24-23.94-1-17,14-28,29-24,0,0,88,31.14,163,31.14s162-31,162-31c18-5,30,9,30,23.79,0,14.21-11,19.21-24,23.94l-88,31.91c-8,3-21,9-26,18.18-6,10.75-5,29.53-2.1,47.59l5.9,29.63L351.21,467.9c2.8,13.15-6.3,25.44-19.4,27.74S308,489,304.12,476.28L266.56,360.35q-2.71-8.34-4.8-16.87L256,320l-5.3,21.65q-2.52,10.35-5.8,20.48L208,476.18c-4,12.85-14.5,21.75-27.6,19.46S158,480.05,160.94,467.9l37.39-163.83Z"
                    ></path>
                  </g>
                </svg>
                {{ lang === 'ar' ? 'إمكانية الوصول' : 'Accessibility' }}
              </a>
            </li>
            <li>
              <a
                class="sub-link"
                [href]="
                  lang === 'ar'
                    ? mainWebsiteLink + '/ar/accessibility#sign-language'
                    : mainWebsiteLink + '/en/accessibility#sign-language'
                "
                target="”_blank”"
              >
                <svg
                  width="20px"
                  height="20px"
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#544f4f"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      fill="var(--ci-primary-color, #544f4f)"
                      d="M256.16,72c65.3.46,118.745,53.964,119.131,119.269a120.126,120.126,0,0,1-33.161,83.545l22.631,22.631a152.141,152.141,0,0,0,42.53-106.365C406.8,108.36,339.105,40.586,256.385,40A150.765,150.765,0,0,0,149.849,82.536l22.629,22.628A119.24,119.24,0,0,1,256.16,72Z"
                      class="ci-primary"
                    ></path>
                    <path
                      fill="var(--ci-primary-color, #544f4f)"
                      d="M359.293,337.235h0l-32-32h0L243.3,221.241l-42.29-42.29h0l-24.843-24.843h0L38.058,16H15.293V38.489l98.294,98.294A151.914,151.914,0,0,0,103.293,192v32h32V192A120.77,120.77,0,0,1,139,162.2l28.324,28.324c-.021.791-.034,1.585-.034,2.381v85.729l5.089,5.082A118.419,118.419,0,0,1,207.293,368h32a150.125,150.125,0,0,0-40-102.453V222.489l128,128v26.178A63.4,63.4,0,0,1,263.96,440H239.293v32H263.96a95.452,95.452,0,0,0,95.161-89.684L472.805,496h22.488V473.234Z"
                      class="ci-primary"
                    ></path>
                    <path
                      fill="var(--ci-primary-color, #544f4f)"
                      d="M254.628,104A87.158,87.158,0,0,0,195.3,127.991l22.62,22.62A55.232,55.232,0,0,1,254.865,136h.428a56,56,0,0,1,56,56h32a88,88,0,0,0-88.665-88Z"
                      class="ci-primary"
                    ></path>
                  </g>
                </svg>
                {{
                  lang === 'ar'
                    ? 'مترجم لغة الإشارة'
                    : 'Sign Language Interpreter'
                }}
              </a>
            </li>
          </ul>
        </li>

        <!-- Mobile language (kept) -->
        <li class="row language-mobile">
          <div class="row-main">
            <div class="row-label">
              <svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M12 2a10 10 0 100 20 10 10 0 000-20zm7.93 9H16.1a15.6 15.6 0 00-.69-4.02A8.02 8.02 0 0119.93 11zM12 4a13.6 13.6 0 011.87 5H10.13A13.6 13.6 0 0112 4zM4.07 13h3.83a15.6 15.6 0 00.69 4.02A8.02 8.02 0 014.07 13zM7.9 11H4.07A8.02 8.02 0 018.59 6.98 15.6 15.6 0 007.9 11zm2.23 2h3.74a11.9 11.9 0 01-1.87 5A11.9 11.9 0 0110.13 13zm6.97 0h3.83A8.02 8.02 0 0115.41 17.02 15.6 15.6 0 0017.1 13z"
                />
              </svg>
              <span>{{ lang === 'ar' ? 'اللغة' : 'Language' }}</span>
            </div>

            <!-- Rectangular Toggle -->
            <label
              class="lang-toggle-rect"
              [attr.dir]="lang === 'ar' ? 'rtl' : 'ltr'"
            >
              <input
                type="checkbox"
                [checked]="lang === 'en'"
                (change)="toggleLangMobile()"
                aria-label="Toggle language"
              />
              <span class="track">
                <span class="opt opt-ar">عربي</span>
                <span class="opt opt-en">English</span>
                <span class="knob"></span>
              </span>
            </label>
          </div>
        </li>
      </ul>
    </nav>
  </aside>
</header>
